/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';
import { Resource } from './Resource';

export const ProblemResourcePreconditionFailed: core.serialization.ObjectSchema<
    serializers.ProblemResourcePreconditionFailed.Raw,
    Truvity.ProblemResourcePreconditionFailed
> = core.serialization.object({
    actual: core.serialization.string(),
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    expected: Resource,
    instance: core.serialization.string().optional(),
    status: core.serialization.number(),
    title: core.serialization.string(),
});

export declare namespace ProblemResourcePreconditionFailed {
    export interface Raw {
        actual: string;
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        expected: Resource.Raw;
        instance?: string | null;
        status: number;
        title: string;
    }
}
